var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentIconEnt(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.061,
    height: 17.665,
    viewBox: "0 0 17.061 17.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488384",
    "data-name": "Group 488384",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180769",
    "data-name": "Path 180769",
    d: "M114.866,141.023c-.333.61-.656,1.226-1,1.827a1.634,1.634,0,0,1-.368.333,2.242,2.242,0,0,1-.321-.383,3.928,3.928,0,0,1-.29-.724c-.069-.238-.206-.28-.422-.239-.349.067-.7.139-1.051.174a.521.521,0,0,1-.4-.122c-.058-.066-.018-.272.044-.378.5-.849,1.007-1.689,1.52-2.541a3.616,3.616,0,0,1-.816-3.89,3.692,3.692,0,0,1,3.18-2.441c0-.288,0-.57,0-.852a1.418,1.418,0,0,1,1.428-1.421c.557-.007,1.114,0,1.664,0,.211-.692.43-.855,1.128-.855h4.63c.734,0,.94.149,1.163.855.539,0,1.084,0,1.629,0a1.414,1.414,0,0,1,1.461,1.459q0,6.945,0,13.889a1.411,1.411,0,0,1-1.461,1.459q-5.093,0-10.185,0a1.412,1.412,0,0,1-1.456-1.464c0-1.554,0-3.108,0-4.662Zm1.782,2.082c0,.61,0,1.214,0,1.819,0,.507.037.543.55.543h8.581c.529,0,.557-.029.557-.572q0-6.124,0-12.249c0-.071,0-.142,0-.214a.31.31,0,0,0-.343-.358c-.354,0-.708,0-1.054,0-.177.66-.423.854-1.061.854H119.25c-.789,0-.961-.117-1.232-.855h-.847c-.212,0-.478-.04-.5.252-.024.265-.127.548.253.749a3.578,3.578,0,0,1,2,3.352,3.625,3.625,0,0,1-1.053,2.539c.512.853,1.024,1.691,1.518,2.541a.487.487,0,0,1,.029.41c-.045.08-.247.111-.372.1-.341-.038-.678-.106-1.015-.172-.237-.046-.4-.016-.474.261a5.866,5.866,0,0,1-.271.694C117.118,143.212,117.065,143.238,116.648,143.1Zm8.28-11.6c.345,0,.675,0,1,0a.866.866,0,0,1,.972.959q0,6.3,0,12.6a.865.865,0,0,1-.964.968q-4.45,0-8.9,0a.865.865,0,0,1-.961-.97c0-.878-.033-1.758.011-2.634a2.148,2.148,0,0,0-.583-1.388v.307q0,2.1,0,4.2c0,.75.307,1.056,1.059,1.056h9.825c.792,0,1.084-.3,1.084-1.1q0-6.728,0-13.457c0-.107.006-.214,0-.32a.809.809,0,0,0-.678-.767c-.621-.04-1.247-.011-1.867-.011Zm-3.434.855c.806,0,1.612-.006,2.418,0,.3,0,.44-.107.433-.416q-.015-.729,0-1.458c.006-.311-.142-.414-.436-.413q-2.418.009-4.836,0c-.327,0-.443.139-.434.452.013.45,0,.9,0,1.351,0,.419.059.48.468.481C119.906,132.362,120.7,132.36,121.494,132.36Zm-3.135,4.008a3.135,3.135,0,1,0-3.128,3.115A3.113,3.113,0,0,0,118.359,136.368Zm-5.373,3.032-1.178,1.963c.36-.055.639-.082.909-.144a.4.4,0,0,1,.55.288c.075.224.178.439.292.717l1.16-2.133Zm2.745.7,1.16,2.122c.117-.283.224-.508.3-.742a.374.374,0,0,1,.5-.269c.286.056.575.1.955.157l-1.179-1.957Zm-.222-7.453.559.079c.005-.093.01-.151.012-.209.018-.715.318-1.01,1.028-1.012h.939v-.571c-.585,0-1.142-.011-1.7,0a.848.848,0,0,0-.836.845C115.5,132.055,115.509,132.328,115.509,132.646Z",
    transform: "translate(-110.986 -129.511)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180770",
    "data-name": "Path 180770",
    d: "M270.429,201.867v.523h-3.67v-.523Z",
    transform: "translate(-255.664 -196.713)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180771",
    "data-name": "Path 180771",
    d: "M266.729,214.3v-.525h3.67v.525Z",
    transform: "translate(-255.636 -207.769)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180772",
    "data-name": "Path 180772",
    d: "M270.413,241.853v.525h-3.67v-.525Z",
    transform: "translate(-255.649 -233.85)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180773",
    "data-name": "Path 180773",
    d: "M266.733,254.294v-.526h3.67v.526Z",
    transform: "translate(-255.64 -244.917)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180774",
    "data-name": "Path 180774",
    d: "M266.81,281.748h3.653v.529H266.81Z",
    transform: "translate(-255.711 -270.904)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180775",
    "data-name": "Path 180775",
    d: "M270.4,293.842v.526H266.73v-.526Z",
    transform: "translate(-255.637 -282.136)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180776",
    "data-name": "Path 180776",
    d: "M266.744,322.3v-.526h3.671v.526Z",
    transform: "translate(-255.65 -308.077)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180777",
    "data-name": "Path 180777",
    d: "M266.723,334.364v-.526h3.665v.526Z",
    transform: "translate(-255.631 -319.283)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180778",
    "data-name": "Path 180778",
    d: "M231.449,200.011l.417-.338.288.257.717-.839.437.35c-.311.376-.609.741-.913,1.1a.291.291,0,0,1-.506,0C231.745,200.368,231.6,200.2,231.449,200.011Z",
    transform: "translate(-222.869 -194.134)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180779",
    "data-name": "Path 180779",
    d: "M231.393,239.991l.475-.377.179.364.772-.908.44.349c-.323.39-.622.781-.96,1.136a.432.432,0,0,1-.416-.007A3.581,3.581,0,0,1,231.393,239.991Z",
    transform: "translate(-222.817 -231.265)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180780",
    "data-name": "Path 180780",
    d: "M231.406,279.989l.478-.379.176.365.77-.907.439.349c-.315.382-.616.756-.928,1.12a.283.283,0,0,1-.482-.008C231.713,280.36,231.572,280.187,231.406,279.989Z",
    transform: "translate(-222.829 -268.415)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180781",
    "data-name": "Path 180781",
    d: "M231.461,320.029l.449-.367.214.326.76-.881.436.348c-.317.383-.619.759-.933,1.124a.274.274,0,0,1-.457.005C231.773,320.41,231.626,320.226,231.461,320.029Z",
    transform: "translate(-222.88 -305.602)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180782",
    "data-name": "Path 180782",
    d: "M133.358,191.21a2.848,2.848,0,1,1,2.852-2.846A2.85,2.85,0,0,1,133.358,191.21Zm2.283-2.858a2.28,2.28,0,1,0-2.279,2.29A2.29,2.29,0,0,0,135.641,188.351Z",
    transform: "translate(-129.123 -181.524)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180783",
    "data-name": "Path 180783",
    d: "M153.975,206.726c-.657.659-1.3,1.3-1.943,1.947a.278.278,0,0,1-.494-.066c-.192-.35-.359-.714-.556-1.112l.5-.247.411.773,1.7-1.739Z",
    transform: "translate(-148.134 -200.813)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIconEnt);
export default __webpack_public_path__ + "static/media/assessment_icon_ent.7d849867ba159d8e92363996f4a419c3.svg";
export { ForwardRef as ReactComponent };